import { Reveal } from "./Reveal";
import { BRANDS } from "../data/content";

export const BrandsStrip = () => (
  <section className="bg-[#FAF4E9] px-6 py-24 border-t border-[#21302A]/10 overflow-hidden" data-testid="brands-strip">
    <div className="max-w-7xl mx-auto">
      <Reveal className="text-center">
        <p className="eyebrow">The Ministry Family</p>
        <h2 className="font-serif-d text-3xl md:text-4xl text-[#1E3A2B] tracking-tight mt-3">
          One calling. <span className="italic-emph text-[#C0953A]">Many houses.</span>
        </h2>
      </Reveal>
    </div>
    <div className="mt-14 relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#FAF4E9] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#FAF4E9] to-transparent z-10" />
      <div className="brands-track flex gap-6 w-max" data-testid="brands-carousel">
        {[...BRANDS, ...BRANDS].map((b, i) => (
          <div key={`${b.name}-${i}`} data-testid={i < BRANDS.length ? `brand-card-${i}` : undefined}
            className="group shrink-0 w-64 bg-white border border-[#21302A]/10 p-8 flex flex-col items-center text-center gap-4 hover:shadow-xl transition-shadow duration-300">
            <div className="h-28 flex items-center justify-center">
              <img src={b.logo} alt={b.name} className="max-h-28 max-w-[160px] object-contain" />
            </div>
            <div>
              <p className="font-serif-d text-lg text-[#1E3A2B] leading-snug">{b.name}</p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-[#C0953A] mt-1">{b.tag}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
